import { useTranslation } from 'react-i18next'

import { Gender } from '@/common/models/person'
import { validateCPF } from '@/common/utils/validateCPF'
import { z } from '@/lib/zod'

export function ProfileGeneralDataSchema() {
  const { t } = useTranslation('profile')
  const schema = {
    fullName: z.string().nonempty(),
    birthDate: z.date().nullable(),
    documentNumber: z.any(),
    gender: z.nativeEnum(Gender),
    isForeign: z.boolean().optional(),
  }

  return z.object(schema).refine(
    (data) => {
      if (!data.isForeign) {
        const cleanCPF = data.documentNumber.replace(/\D/g, '')
        if (cleanCPF.length !== 11) {
          return false
        }
        return validateCPF(cleanCPF)
      }
      return data.documentNumber.length > 0
    },
    {
      message: t('general_data.schema.document.invalid'),
      path: ['documentNumber'],
    },
  )
}

export type ProfileGeneralDataForm = z.infer<
  ReturnType<typeof ProfileGeneralDataSchema>
>
